/**
 * Insights: clear-all visibility; scroll to top after FacetWP loads (category, tag, or pagination).
 */
(function () {
	function facetHasValue(name) {
		if (typeof FWP === 'undefined' || !FWP.facets) {
			return false;
		}
		const val = FWP.facets[name];
		if (val === undefined || val === null) {
			return false;
		}
		if (Array.isArray(val)) {
			return val.length > 0;
		}
		if (typeof val === 'string') {
			return val.trim() !== '';
		}
		return false;
	}

	function hasActiveFilters() {
		return (
			facetHasValue('post_categories') ||
			facetHasValue('post_tags') ||
			facetHasValue('post_search')
		);
	}

	function init() {
		const clearWrap = document.querySelector('.blog-sidebar__filters-clear');
		const clearBtn = document.querySelector('.blog-sidebar__clear');

		let scrollAfterFacetLoad = false;

		if (document.querySelector('.blog-layout')) {
			document.addEventListener(
				'click',
				function (e) {
					const t = e.target;
					if (!(t instanceof Element)) {
						return;
					}
					if (t.closest('.facetwp-facet-post_categories .facetwp-toggle, .facetwp-facet-post_tags .facetwp-toggle')) {
						return;
					}
					if (
						t.closest('.facetwp-facet-post_categories') ||
						t.closest('.facetwp-facet-post_tags') ||
						t.closest('.facetwp-facet-post_pagination')
					) {
						scrollAfterFacetLoad = true;
					}
				},
				true
			);
		}

		function updateClearVisibility() {
			if (!clearWrap) {
				return;
			}
			const active = hasActiveFilters();
			if (active) {
				clearWrap.removeAttribute('hidden');
			} else {
				clearWrap.setAttribute('hidden', '');
			}
		}

		function maybeScrollToPageTop() {
			if (!scrollAfterFacetLoad) {
				return;
			}
			scrollAfterFacetLoad = false;
			window.requestAnimationFrame(function () {
				window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
			});
		}

		function onFacetLoaded() {
			updateClearVisibility();
			maybeScrollToPageTop();
		}

		function bindFacetHooks() {
			if (typeof FWP !== 'undefined' && FWP.hooks) {
				FWP.hooks.addAction('facetwp/loaded', onFacetLoaded);
				onFacetLoaded();
			}
		}

		if (typeof FWP !== 'undefined' && FWP.hooks) {
			bindFacetHooks();
		} else {
			let attempts = 0;
			const id = window.setInterval(function () {
				attempts += 1;
				if (typeof FWP !== 'undefined' && FWP.hooks) {
					window.clearInterval(id);
					bindFacetHooks();
				} else if (attempts > 80) {
					window.clearInterval(id);
				}
			}, 50);
		}

		if (clearBtn) {
			clearBtn.addEventListener('click', function (e) {
				e.preventDefault();
				if (typeof FWP !== 'undefined' && typeof FWP.reset === 'function') {
					FWP.reset();
				}
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
